import React from 'react';
export default function ListItem(props) {
  return /*#__PURE__*/React.createElement("li", null, props.children);
}